import React, { useState, useEffect } from "react";
import "../index.css";
import { fetchFromAPI } from "../lib/api";

const defaultTestimonies = [
    {
        id: 1,
        name: "144 Daniel Ogarekpe",
        role: "Member",
        quote: "Since I started reading the Everlasting Gospel, my understanding of God's word has deepened and my faith has grown stronger. Doors that once seemed closed are now opening, and I keep experiencing divine help in unexpected ways. Truly, serving God brings peace and blessings. I give all the glory to The Holy Father",
        avatar: "/test.jpg",
    },
    {
        id: 2,
        name: "PCS Usenetim Gregory",
        role: "Managing Director ICT",
        quote: "Ever since I began studying the Everlasting Gospel, my life has changed for the better. My prayers have become more powerful, and I see God’s hand guiding me daily. Challenges that once worried me now turn into testimonies. Indeed, serving God is rewarding. I return all glory to The Holy Father.",
        avatar: "/test.jpg",
    },
    {
        id: 3,
        name: "DV Mirable Barile",
        role: "Member",
        quote: "Reading the Everlasting Gospel has transformed my spiritual life. I now feel closer to God, and my days are filled with joy, favor, and protection. What used to be difficult has become easy through faith. Truly, there is great blessing in serving God. I give all the glory to The Holy Father.",
        avatar: "/test.jpg",
    },
    {
        id: 4,
        name: "Bro Oku Akpabio",
        role: "Member",
        quote: "Being part of this church has deepened my walk with God. Through sound teaching and genuine love from the brethren, I have grown stronger in faith and more confident in God's plan for my life.",
        avatar: "/test.jpg",
    },
];

const Testimony = () => {
    const [testimonies, setTestimonies] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [current, setCurrent] = useState(0);
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        const fetchTestimonies = async () => {
            try {
                const data = await fetchFromAPI("/testimonies") || [];
                if (data.length > 0) {
                    const formattedTestimonies = data.map((item, index) => ({
                        id: item.id || item._id || index,
                        name: item.memberName || item.author || "Anonymous",
                        role: item.role || item.title || "Member",
                        quote: item.quote || item.message || item.text || item.content || item.testimony || "",
                        avatar: item.avatar || item.image || item.photo || "/test.jpg",
                    }));
                    setTestimonies(formattedTestimonies);
                } else {
                    setTestimonies(defaultTestimonies);
                }
            } catch (error) {
                console.error("Error fetching testimonies:", error);
                setTestimonies(defaultTestimonies);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTestimonies();
    }, []);

    const goTo = (index) => {
        if (animating || index === current) return;
        setAnimating(true);
        setTimeout(() => {
            setCurrent(index);
            setAnimating(false);
        }, 300);
    };

    const prev = () => goTo(current === 0 ? testimonies.length - 1 : current - 1);
    const next = () => goTo(current === testimonies.length - 1 ? 0 : current + 1);

    useEffect(() => {
        if (testimonies.length === 0) return;
        const timer = setInterval(() => {
            setCurrent((c) => (c === testimonies.length - 1 ? 0 : c + 1));
        }, 6000);
        return () => clearInterval(timer);
    }, [testimonies.length]);

    const t = testimonies[current];

    return (
        <section className="bg-white w-full py-16 px-4 md:px-12 lg:px-20">
            <div className="max-w-6xl mx-auto">

                {/* Section Label */}
                <div className="flex items-center gap-2 mb-10">
                    <span className="block w-7 h-px bg-blue-600" />
                    <span className="text-blue-600 text-xs font-semibold tracking-widest uppercase">
                        Testimonies
                    </span>
                </div>

                {isLoading ? (
                    <div className="flex justify-center items-center min-h-[480px] md:min-h-[420px]">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    </div>
                ) : t ? (
                    <>
                        {/* Main Card */}
                        <div className="relative rounded-sm overflow-visible min-h-[480px] md:min-h-[420px] flex items-end">

                            {/* Background Image */}
                            <img
                                src={t.avatar || "/test.jpg"}
                                alt="Testimony background"
                                className="absolute inset-0 w-full h-full object-cover object-center rounded-sm"
                            />

                            {/* 40% Dark Overlay */}
                            <div className="absolute inset-0 bg-black/40 rounded-sm" />

                            {/* Bottom-left corner accent */}
                            <div className="absolute -bottom-3 -left-3 w-16 h-16 border-l-2 border-b-2 border-blue-400 z-10 pointer-events-none" />

                            {/* Prev Arrow */}
                            <button
                                onClick={prev}
                                aria-label="Previous testimony"
                                className="absolute left-4 top-1/2 -translate-y-1/2 z-30
              w-9 h-9 flex items-center justify-center
              rounded-sm bg-white/20 backdrop-blur-sm border border-white/30
              text-white hover:bg-white/40 transition-all duration-200"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>

                            {/* Next Arrow */}
                            <button
                                onClick={next}
                                aria-label="Next testimony"
                                className="absolute right-4 top-1/2 -translate-y-1/2 z-30
              w-9 h-9 flex items-center justify-center
              rounded-sm bg-white/20 backdrop-blur-sm border border-white/30
              text-white hover:bg-white/40 transition-all duration-200"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                            </button>

                            {/* Testimony Content */}
                            <div
                                className={`relative z-20 w-full px-10 md:px-20 lg:px-28 py-12 transition-opacity duration-300 ${animating ? "opacity-0" : "opacity-100"
                                    }`}
                            >
                                {/* Quote mark */}
                                <div className="text-blue-400 text-7xl font-serif leading-none mb-2 select-none">
                                    "
                                </div>

                                <p className="text-white text-lg md:text-xl leading-relaxed mb-8 max-w-3xl">
                                    {t.quote}
                                </p>

                                {/* Author */}
                                <div className="flex items-center gap-4">

                                    <div>
                                        <p className="text-white font-semibold text-sm">{t.name}</p>
                                        <p className="text-blue-300 text-xs tracking-wide">{t.role}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Slide Indicators */}
                        <div className="flex items-center justify-center gap-1.5 mt-6">
                            {testimonies.map((_, i) => (
                                <button
                                    key={i}
                                    onClick={() => goTo(i)}
                                    aria-label={`Go to testimony ${i + 1}`}
                                    className={`rounded-full transition-all duration-300 ${i === current
                                        ? "bg-blue-600 w-5 h-1.5"
                                        : "bg-gray-300 w-1.5 h-1.5 hover:bg-blue-300"
                                        }`}
                                />
                            ))}
                        </div>
                    </>
                ) : (
                    <div className="text-center py-10 text-gray-500 min-h-[480px] md:min-h-[420px] flex items-center justify-center">
                        No testimonies available.
                    </div>
                )}

            </div>
        </section>
    );
};

export default Testimony;